import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { fetchTemplates, createTemplate, fetchTemplate, modifyTemplate, deleteTemplateApi, changeStatus } from '../../api/templateApi';

export const getTemplates = createAsyncThunk('template/getTemplates', async ({payload}, { rejectWithValue }) => {
  try {
    const response = await fetchTemplates(payload);
    return response.data.data;
  } catch (error) {
    return rejectWithValue(error.response.data);
  }
});

export const addTemplate = createAsyncThunk('template/addTemplate', async (payload, { rejectWithValue }) => {
  try {
    const response = await createTemplate(payload);
    return response.data;
  } catch (error) {
    return rejectWithValue(error.response.data);
  }
});

export const getTemplateDetails = createAsyncThunk('template/getTemplateDetails', async (templateId, { rejectWithValue }) => {
  try {
    const response = await fetchTemplate(templateId);
    return response.data;
  } catch (error) {
    return rejectWithValue(error.response.data);
  }
});

export const updateTemplate = createAsyncThunk('template/updateTemplate', async (payload, { rejectWithValue }) => {
  try {
    const response = await modifyTemplate(payload);
    return response.data;
  } catch (error) {
    return rejectWithValue(error.response.data);
  }
});

export const deleteTemplate = createAsyncThunk('template/deleteTemplate', async (templateId, { rejectWithValue }) => {
  try {
    const response = await deleteTemplateApi(templateId);
    return response.data;
  } catch (error) {
    return rejectWithValue(error.response.data);
  }
});

export const changeActiveStatus = createAsyncThunk('template/changeDefaultStatus', async (templateId, { rejectWithValue }) => {
  try {
    const response = await changeStatus(templateId);
    return response.data;
  } catch (error) {
    return rejectWithValue(error.response.data);
  }
});

const templateSlice = createSlice({
  name: 'template',
  initialState: {
    templates: [],
    isLoading: false,
    error: null,
  },
  extraReducers: (builder) => {
    builder
      .addCase(getTemplates.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getTemplates.fulfilled, (state, action) => {
        state.isLoading = false;
        state.templates = action.payload;
      })
      .addCase(getTemplates.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
  },
});

export default templateSlice.reducer;
